import {
   HealthcareOrganizationRegisteringAuthority,
   HealthcareOrganizationRegisteringAuthorityQuery,
} from '@dreryk/egabinet-healthcare-provider-frontend-api';

import { CqrsQueryPerformResult, performCqrsQuerySearch } from '@dreryk/command-query-react-common';
import { OrderedPagination, paginations } from '@dreryk/command-query-ws-client';
import { commonTranslationKeys, createTranslatedText, FieldControllerProps } from '@dreryk/react-common';
import { ClassNameProp, Select } from '@dreryk/react-components';

import { healthcareOrganizationTranslationKeys } from '../../../translations';

const REGISTERING_AUTHORITY_PAGINATION: OrderedPagination<
   HealthcareOrganizationRegisteringAuthority,
   HealthcareOrganizationRegisteringAuthority[]
> = paginations.all<HealthcareOrganizationRegisteringAuthority>().orderedBy('code', paginations.Direction.ASCENDING);

const triggerLabelExtractor = (registeringAuthority?: HealthcareOrganizationRegisteringAuthority): string =>
   `${registeringAuthority?.name} (${registeringAuthority?.code})`;

type RegisteringAuthoritySelectProps = FieldControllerProps<
   'registeringAuthority',
   HealthcareOrganizationRegisteringAuthority | null
> &
   ClassNameProp;

const registerAuthoritiesSearchCreator = () => {
   return async (): CqrsQueryPerformResult<HealthcareOrganizationRegisteringAuthority[]> =>
      performCqrsQuerySearch<HealthcareOrganizationRegisteringAuthority>(
         () => new HealthcareOrganizationRegisteringAuthorityQuery(),
         REGISTERING_AUTHORITY_PAGINATION,
         {
            cacheTime: 'long',
         }
      );
};

export const RegisteringAuthoritySelect = (props: RegisteringAuthoritySelectProps): JSX.Element => {
   const controller = props.register(props.name, { required: props.required });

   return (
      <Select<HealthcareOrganizationRegisteringAuthority>
         className={props.className}
         triggerLabelExtractor={triggerLabelExtractor}
         testId={props.name}
         label={healthcareOrganizationTranslationKeys.registeringAuthority}
         placeholder={commonTranslationKeys.choose}
         controller={controller}
      >
         <Select.SearchCreator<HealthcareOrganizationRegisteringAuthority>
            searchCreator={registerAuthoritiesSearchCreator}
         >
            {({ items }) => (
               <>
                  {(items ?? []).map((item) => (
                     <Select.Item
                        item={item}
                        label={createTranslatedText(`${item.name} (${item.code})`)}
                        testId={item.id}
                        key={item.id}
                     />
                  ))}
               </>
            )}
         </Select.SearchCreator>
      </Select>
   );
};
